import { ReactNode } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  change?: {
    value: string | number;
    trend: "up" | "down" | "neutral";
  };
  status?: {
    label: string;
    type: "success" | "warning" | "info" | "danger" | "neutral";
  };
}

export const StatsCard = ({
  title,
  value,
  icon,
  change,
  status,
}: StatsCardProps) => {
  return (
    <Card>
      <CardContent className="p-5">
        <div className="flex items-center">
          <div className={cn(
            "flex-shrink-0 rounded-md p-3",
            status?.type === "success" ? "bg-success/10" : 
            status?.type === "warning" ? "bg-warning/10" : 
            status?.type === "info" ? "bg-info/10" : 
            status?.type === "danger" ? "bg-destructive/10" : 
            "bg-primary/10"
          )}>
            {icon}
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 h-10">
                {typeof title === 'string' ? title.split(' ').slice(0, 1).join(' ') : title}
                <br />
                {typeof title === 'string' ? title.split(' ').slice(1).join(' ') : null}
              </dt>
              <dd className="flex items-baseline">
                <div className="text-2xl font-bold text-gray-900">{value}</div>
                {change && (
                  <div className={cn(
                    "ml-2 flex items-baseline text-sm font-medium", 
                    change.trend === "up" ? "text-success" : 
                    change.trend === "down" ? "text-destructive" : 
                    "text-gray-500"
                  )}>
                    {change.trend === "up" ? <ArrowUp className="h-4 w-4 mr-1" /> : null}
                    {change.trend === "down" ? <ArrowDown className="h-4 w-4 mr-1" /> : null}
                    {change.value}
                  </div>
                )}
                {status && (
                  <div className={cn(
                    "ml-2 flex items-baseline text-sm font-medium",
                    status.type === "success" ? "text-success" : 
                    status.type === "warning" ? "text-warning" : 
                    status.type === "info" ? "text-info" : 
                    status.type === "danger" ? "text-destructive" : 
                    "text-gray-500"
                  )}>
                    <span className="ml-1">{status.label}</span>
                  </div>
                )}
              </dd>
            </dl>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
